import { render, staticRenderFns } from "./payment-logos.vue?vue&type=template&id=09571160&scoped=true"
import script from "./payment-logos.vue?vue&type=script&lang=ts"
export * from "./payment-logos.vue?vue&type=script&lang=ts"
import style0 from "./payment-logos.vue?vue&type=style&index=0&id=09571160&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09571160",
  null
  
)

export default component.exports